@if (spinnerVisible) {
  <ion-backdrop [visible]="true"></ion-backdrop>
  <ion-spinner name="bubbles"></ion-spinner>
}

